'use client'

import { useEffect, useRef } from 'react'

type EmbedBlockProps = { code: string | null | undefined }

export default function EmbedBlock({ code }: EmbedBlockProps) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current || !code) return

    ref.current.innerHTML = code

    const scripts = Array.from(ref.current.querySelectorAll('script'))
    for (const oldScript of scripts) {
      const newScript = document.createElement('script')
      for (const attr of Array.from(oldScript.attributes)) {
        newScript.setAttribute(attr.name, attr.value)
      }
      newScript.textContent = oldScript.textContent
      oldScript.replaceWith(newScript)
    }
  }, [code])

  if (!code) return null

  return <div ref={ref} />
}
